export default __webpack_public_path__ + "static/media/logo-apple.1098fa39.svg";